import { DigitalClockPopupTranslations } from "./types";

export const enTranslations: DigitalClockPopupTranslations = {
    title: "Progress through Shift"
}